// Unpublished Work © 2021-2025 Deere & Company.

export const SUPPORTED_COUNTRY_CODES = [
    {
        code: 'AU',
        translationKey: 'AUSTRALIA'
    },
    {
        code: 'CA',
        translationKey: 'Canada'
    },
    {
        code: 'DE',
        translationKey: 'ONLINK_GERMANY'
    },
    {
        code: 'ES',
        translationKey: 'ONLINK_SPAIN'
    },
    {
        code: 'FR',
        translationKey: 'ONLINK_FRANCE'
    },
    {
        code: 'GB',
        translationKey: 'ONLINK_UNITED_KINGDOM'
    },
    {
        code: 'IE',
        translationKey: 'ONLINK_IRELAND'
    },
    {
        code: 'IT',
        translationKey: 'ONLINK_ITALY'
    },
    {
        code: 'NZ',
        translationKey: 'NEW_ZEALAND'
    },
    {
        code: 'SE',
        translationKey: 'ONLINK_SWEDEN'
    },
    {
        code: 'US',
        translationKey: 'ONLINK_UNITED_STATES'
    }
];
